// frontend/src/design-system/components/NoAccessState.tsx
//
// Calm "you don't have access" card for pages/sections that 403 for the
// current role. Deliberately NOT the red ErrorState — a permission gate is
// expected behavior, not a failure. Use ErrorState for genuine failures.

import * as React from 'react';
import { Lock } from 'lucide-react';
import { EmptyState } from './EmptyState';

interface Props {
  title?: string;
  description?: string;
}

export function NoAccessState({
  title = "You don't have access to this page",
  description = "Your role doesn't include this area. Ask a workspace owner or admin if you think you should have access.",
}: Props) {
  return (
    <EmptyState
      icon={<Lock />}
      tone="muted"
      title={title}
      description={description}
    />
  );
}
